export default __webpack_public_path__ + "static/media/coin.1beb0a74.png";